/** Returns the sum of char code values for a given string */
export default function calculateStringValue(text: string): number {
  return text.split('').reduce((sum, char) => (sum += char.charCodeAt(0)), 0)
}
